import Image from 'next/image'
import Carousel from '../Carousel/Carousel'

interface Props {
  title: string
  bgImage: StrapiImageFile
  lists: {
    title: string
    description: string
    color: string
    image?: StrapiImageFile
  }[]
}

const AllVideoFormats = ({ title, bgImage, lists }: Props) => {
  return (
    <section>
      <div className="relative">
        <Image
          src={bgImage.url}
          alt={bgImage.alternativeText ?? ''}
          height={bgImage.height}
          width={bgImage.width}
          className="absolute w-full h-full object-top"
        />

        <div className="container | py-10 md:py-18 relative z-10">
          <h2
            className="text-3xl lg:text-5xl font-semibold text-white | max-w-col-7"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>

        <div className="pb-10 md:pb-18">
          <Carousel
            navigationType="arrow"
            sliderClassName="first:pl-8"
            slides={lists.map(list => (
              <div key={list.title} className="text-blue-web-90 w-[298px]">
                <div className="snap-start | relative">
                  <div
                    className="flex flex-col | text-left rounded-xl"
                    style={{ backgroundColor: list.color }}
                  >
                    <div className="relative w-full h-48">
                      <Image
                        src={list.image?.url ?? ''}
                        alt={list.image?.alternativeText ?? ''}
                        height={list.image?.height}
                        width={list.image?.width}
                        className="object-cover w-full h-full | rounded-t-xl"
                      />
                    </div>
                    <div className="px-6 py-5">
                      <h3
                        className="font-heading | text-xl text-black font-semibold | mb-4"
                        dangerouslySetInnerHTML={{ __html: list.title }}
                      />

                      {list.description ? (
                        <div
                          className="font-body text-sm text-gray-70 | line-clamp-2 | h-9"
                          dangerouslySetInnerHTML={{ __html: list.description }}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          />
        </div>
      </div>
    </section>
  )
}

export default AllVideoFormats
